import React from 'react'
import { FormattedHTMLMessage, NavMenuItem, AppSvg, newIcons } from '@web/walter-ui-kit'

import { SettingsTabs } from '../../types'
import { lang } from './lang'
import s from './s.module.css'

interface Props {
    tab: SettingsTabs
    setTab: (val: SettingsTabs) => void
}

function ArrowIcon() {
    return (
        <div className={s.afterIcon}>
            <AppSvg path="new-icons" size={24} svgName={newIcons.ic24ChevronRight} />
        </div>
    )
}

// eslint-disable-next-line max-lines-per-function
function Menu({ setTab, tab }: Props) {
    return (
        <div className={s.menu}>
            {/*<NavMenuItem*/}
            {/*    icon={<AppSvg size={24} path="new-icons" svgName={newIcons.ic24Password} />}*/}
            {/*    type="button"*/}
            {/*    size="l"*/}
            {/*    onClick={() => setTab(SettingsTabs.pinCode)}*/}
            {/*    selected={tab === SettingsTabs.pinCode}*/}
            {/*    dataPointer="pin_tab"*/}
            {/*    after={<ArrowIcon />}*/}
            {/*    variant="secondary"*/}
            {/*>*/}
            {/*    <FormattedHTMLMessage {...lang.pin} />*/}
            {/*</NavMenuItem>*/}
            <NavMenuItem
                icon={<AppSvg size={24} path="new-icons" svgName={newIcons.ic24ShieldCheck} />}
                type="button"
                size="l"
                onClick={() => setTab(SettingsTabs.threeDSGeneral)}
                selected={tab === SettingsTabs.threeDSGeneral}
                dataPointer="3ds_tab"
                after={<ArrowIcon />}
                variant="secondary"
            >
                <FormattedHTMLMessage {...lang.threeDs} />
            </NavMenuItem>
            <NavMenuItem
                icon={<AppSvg size={24} path="new-icons" svgName={newIcons.ic24Lock} />}
                type="button"
                size="l"
                onClick={() => setTab(SettingsTabs.block)}
                selected={tab === SettingsTabs.block}
                dataPointer="block_tab"
                after={<ArrowIcon />}
                variant="secondary"
            >
                <FormattedHTMLMessage {...lang.block} />
            </NavMenuItem>
        </div>
    )
}

export default Menu
